<template>
    <div class="day-timeline-body">
        <div v-if="timelineData && (timelineData.line1 || timelineData.line2)" class="w-100 overflow-x-auto h-100">
            <day-line-timeline v-for="line in lines" :key="line.key" :line-data="timelineData[line.key]" :header="line.header" class="timeline-line"></day-line-timeline>
        </div>
    </div>
</template>
<style scoped>
    .day-timeline-body {
        width: 100%;
        height: 100%;
        padding: 5px;
        position: relative;
    }
    .timeline-line {
        border-bottom:1px solid grey;
    }
</style>
<script>
    import { mapActions } from "vuex";
    export default {
        name: "DayTimeline",
        props: {
            openView: Boolean,
            timelineData: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                lines: [
                    { key: 'line1', header: 'Line 1' },
                    { key: 'line2', header: 'Line 2' }
                ]
            };
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
        }
    };
</script>
